import _funzioni from './funzioni';

const _localStorage = {
  set: function (name, val) {
    localStorage.setItem(name, val);
  },
  remove: function (name) {
    localStorage.removeItem(name);
  },
  get: function (name) {
    return localStorage.getItem(name);
  },
  setJSON: function  (name, obj)
  {
    _localStorage.set(name, JSON.stringify(obj));
  },
  getJSON: function  (name)
  {
    let obj = _localStorage.get(name);
    return _funzioni.isValidJSON(obj) && JSON.parse(obj) || false;
  },
}

export { _localStorage as default };
